import { render } from "./UserViewActionButtons.vue?vue&type=template&id=106e3d4c"
import script from "./UserViewActionButtons.vue?vue&type=script&lang=js"
export * from "./UserViewActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__